import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import { CookieBanner } from "./components/CookieBanner";
import HomePage from "./pages/HomePage";
import BrandschutzhelferPage from "./pages/BrandschutzhelferPage";
import SanitaetsdienstePage from "./pages/SanitaetsdienstePage";
import TerminePage from "./pages/TerminePage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import AnmeldungErfolgreichPage from "./pages/AnmeldungErfolgreichPage";
import ContactPage from "./pages/ContactPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import CookieRichtliniePage from "./pages/CookieRichtliniePage";
import DatenschutzSocialMediaPage from "./pages/DatenschutzSocialMediaPage";
import AdminPage from "./pages/AdminPage";
import BookingManagePage from "./pages/BookingManagePage";
import BetrieblicheErsteHilfePage from "./pages/BetrieblicheErsteHilfePage";
import InhouseKursePage from "./pages/InhouseKursePage";
import ErsatzbescheinigungPage from "./pages/ErsatzbescheinigungPage";

// White-label: Remove Emergent badge
const removeEmergentBadge = () => {
  const selectors = [
    '#emergent-badge',
    '[id*="emergent-badge"]',
    'a[href*="emergent.sh"]'
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      if (el && el.tagName !== 'SCRIPT') el.remove();
    });
  });
};

function App() {
  // Remove Emergent badge on mount and continuously
  useEffect(() => {
    removeEmergentBadge();
    const interval = setInterval(removeEmergentBadge, 100);
    
    // MutationObserver to catch dynamically inserted badge
    const observer = new MutationObserver(() => removeEmergentBadge());
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/brandschutzhelfer" element={<BrandschutzhelferPage />} />
            <Route path="/sanitaetsdienste" element={<SanitaetsdienstePage />} />
            <Route path="/termine" element={<TerminePage />} />
            <Route path="/termine/success" element={<PaymentSuccessPage />} />
            <Route path="/anmeldung-erfolgreich" element={<AnmeldungErfolgreichPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/cookie-richtlinie" element={<CookieRichtliniePage />} />
            <Route path="/datenschutz-social-media" element={<DatenschutzSocialMediaPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/buchung/aendern" element={<BookingManagePage />} />
            <Route path="/betriebliche-erste-hilfe" element={<BetrieblicheErsteHilfePage />} />
            <Route path="/inhouse-kurse" element={<InhouseKursePage />} />
            <Route path="/ersatzbescheinigung" element={<ErsatzbescheinigungPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
